<form [formGroup]="form" #formData (keydown.enter)="$event.preventDefault()">
  <h2>{{ ((item.isMilestone) ? 'editar_hito' : 'editar_checklist') | translate }}</h2>
  <div class="form-table">
    <div *ngIf="!item.isMilestone" class="form-item">
      <label>{{ 'nombre' | translate }}</label>
      <lib-form-textbox
        controlName="name"
        id="name"
        [value]="form.value.name">
      </lib-form-textbox>
      <!-- <input formControlName="name" type="text" id="name"> -->
      <span *ngIf="genericFormService.hasWrongValue(form, 'name')" class="form-error">{{ genericFormService.getFieldError(form, 'name') }}</span>
    </div>
    <div class="form-item">
      <label>{{ 'descripcion' | translate }}</label>
      <lib-form-textarea
        controlName="description"
        id="description"
        [value]="form.value.description"
        [maxlength]="500">
      </lib-form-textarea>
      <span *ngIf="genericFormService.hasWrongValue(form, 'description')" class="form-error">{{ genericFormService.getFieldError(form, 'description') }}</span>
    </div>
  </div>
  <div class="form-row form-button-row text-right">
    <button class="cancel" (click)="cancel()">{{ 'cancelar' | translate | uppercase }}</button>
    <button class="submit" (click)="accept()">{{ 'aceptar' | translate | uppercase }}</button>
  </div>
</form>
